import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import { Link } from "react-router-dom";
import { appService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import Logo from "components/Logo";

class RememberPassword extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			submitted: false,
			email: "",
			errors: {},
			response_ok: false,
		};
	}

	handleChange = (event) => {
		this.setState({
			[event.target.id]: event.target.value,
		});
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	handleSubmit = async (event) => {
		event.preventDefault();
		this.setState({ isLoading: true });
		var response_ok = false;

		var response = await appService.resetPassword(this.state.email);
		// console.log(response);

		if (response.errors === undefined) {
			response_ok = true;
		}

		this.setState({
			submitted: true,
			isLoading: false,
			response_ok: response_ok,
			errors: errorFormating(response),
		});
	};

	// Habilita el botón solo si hay email
	enableSubmitButton() {
		return this.state.email.length > 0;
	}

	render() {
		const { t } = this.props;
		return (
			<div className="Auth">
				<div className="remember-block">
					<div className="login-container">
						<Logo className="logo" type="logo" />

						<form onSubmit={this.handleSubmit} className="login-form">
							<FormGroup
								className="form-group login-form-group"
								controlId="email"
							>
								<FormLabel>{t("login.email")}</FormLabel>
								<FormControl
									autoFocus
									type="email"
									value={this.state.email}
									onChange={this.handleChange}
									isInvalid={this.checkValidField("email")}
									placeholder={t("rememberPassword.emailPlaceholder")}
								/>
								<FormControl.Feedback type="invalid">
									{this.state.errors.email}
								</FormControl.Feedback>
							</FormGroup>

							<SubmitButton
								block
								type="submit"
								isLoading={this.state.isLoading}
								text={t("rememberPassword.submit")}
								loadingText={t("rememberPassword.submitting")}
								disabled={!this.enableSubmitButton()}
							/>
						</form>

						{this.state.response_ok && (
							<div
								className="alert alert-success alert-dismissible fade show"
								role="alert"
							>
								{t("rememberPassword.successMessage")}
							</div>
						)}

						{this.state.errors.employee_id && (
							<div
								className="alert alert-danger alert-dismissible fade show mt15"
								role="alert"
							>
								{this.state.errors.employee_id}
							</div>
						)}
					</div>

					<div className="login-links">
						<p>
							{t("rememberPassword.haveAccount")} <Link to="/login">{t("rememberPassword.signIn")}</Link>
						</p>
					</div>
				</div>
			</div>
		);
	}
}

export default withTranslation()(RememberPassword);
